import ApplicationController from './application_controller';

export default class extends ApplicationController {
  static targets = ["modal", "overlay"];
  static values = {
    hideMain: { type: Boolean, default: false },
    closeOnClickOutside: { type: Boolean, default: false }
  };

  declare modalTarget: HTMLElement;
  declare hasModalTarget: boolean;
  declare overlayTarget: HTMLElement;
  declare hasOverlayTarget: boolean;
  declare hideMainValue: boolean;
  declare closeOnClickOutsideValue: boolean;

  private boundClickOutside: ((event: MouseEvent) => void) | null = null;

  open(event?: Event): void {
    if (event) event.preventDefault();

    if (this.hideMainValue) {
      const main = document.querySelector('main');
      if (main) main.style.display = 'none';
    }

    if (this.hasOverlayTarget) {
      this.overlayTarget.classList.remove('hidden');
    }

    if (this.hasModalTarget) {
      this.modalTarget.classList.remove('hidden');
      this.modalTarget.style.display = 'flex';
    }

    if (this.closeOnClickOutsideValue) {
      this.boundClickOutside = this.clickOutside.bind(this);
      document.addEventListener('click', this.boundClickOutside);
    }
  }

  close(event?: Event): void {
    if (event) event.preventDefault();

    if (this.hideMainValue) {
      const main = document.querySelector('main');
      if (main) main.style.display = '';
    }

    if (this.hasOverlayTarget) {
      this.overlayTarget.classList.add('hidden');
    }

    if (this.hasModalTarget) {
      this.modalTarget.classList.add('hidden');
      this.modalTarget.style.display = 'none';
    }

    if (this.boundClickOutside) {
      document.removeEventListener('click', this.boundClickOutside);
      this.boundClickOutside = null;
    }
  }

  clickOutside(event: MouseEvent): void {
    if (this.hasModalTarget && !this.modalTarget.contains(event.target as Node)) {
      this.close();
    }
  }

  stopPropagation(event: Event): void {
    event.stopPropagation();
  }
}
